import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { relativeTime } from "./format";

// Gauge shows value against a ceiling. A ceiling of 0 (or less) means "unlimited" —
// e.g. ICAP MaxConnections=0 — so there's no utilization to show; render the current
// value with a "no limit" note and a neutral, empty track.
export default function Gauge({ label, value, max, at }: { label: string; value: number; max: number; at?: number }) {
    const unlimited = !(max > 0);
    const pct = unlimited ? 0 : Math.min(100, Math.round((value / max) * 100));
    const color = pct >= 90 ? "error" : pct >= 70 ? "warning" : "primary";
    return (
        <Box sx={{ flex: "1 1 260px", minWidth: 240 }}>
            <Stack direction="row" justifyContent="space-between">
                <Typography variant="subtitle2" color="text.secondary">{label}</Typography>
                <Typography variant="subtitle2">
                    {unlimited ? `${value} · no limit` : `${value} / ${max} (${pct}%)`}
                </Typography>
            </Stack>
            <LinearProgress
                variant="determinate"
                value={unlimited ? 0 : pct}
                color={unlimited ? "inherit" : color}
                sx={{ height: 10, borderRadius: 1, mt: 0.5, opacity: unlimited ? 0.35 : 1 }}
            />
            {at !== undefined && at > 0 && (
                <Typography variant="caption" color="text.secondary">peak {relativeTime(at)}</Typography>
            )}
        </Box>
    );
}
